import Client from "../AxiosClient";
const activeURI = '/public/licenses/active';
const infoURI = '/public/licenses/info';

export default {

    async getInfo() {
        try {
            let {data} = await Client.get(`${infoURI}`);
            return data;
        } catch(error) {
            console.log(error);
            return { error: error};
        }
    },

    async active(license_key) {
        try {
            let {data} = await Client.post(`${activeURI}`, {license_key: license_key});
            console.log(data)
            return data;
        } catch(error) {
            console.log(error);
            return { error: error };
        }
        
    }

}